module.exports = __webpack_public_path__ + "img/lancamento_banner_desktop_procura.62a6428b.webp";